<template>
  <div>
    <el-menu
      :default-active="this.$route.path"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="transparent"
      text-color="#fff"
      router
    >
      <el-menu-item class="first-level-menu" index="/Home">首页</el-menu-item>
      <el-menu-item class="first-level-menu" index="/User">数据</el-menu-item>
      <!-- <el-submenu index="">
        <template slot="title">数据</template>
        <el-menu-item class="second-level-menu" index="/User"
          >期货</el-menu-item
        >
        <el-menu-item class="second-level-menu" index="/PersonalSpot"
          >现货</el-menu-item
        >
        <el-menu-item class="second-level-menu" index="/IndividualOption"
          >期权</el-menu-item
        >
      </el-submenu> -->
      <el-menu-item class="first-level-menu">
        <a target="_blank" href="https://rta-finance.com/"> 官网</a>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Aside',
  data() {
    return {};
  },
  methods: {
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
// .el-menu--horizontal > .el-menu-item.is-active {
//   border-bottom: none;
//   color: rgba(237, 189, 136, 1);
// }
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: rgba(237, 189, 136, 1);
}
.el-menu--horizontal > .el-submenu .el-menu-item:hover {
  background: rgba(239, 195, 148, 1) !important;
  color: rgba(51, 53, 62, 1) !important;
}
.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
}
.first-level-menu:hover {
  background: transparent !important;
  color: rgba(237, 189, 136, 1) !important;
}
.first-level-menu a:hover {
  color: rgba(237, 189, 136, 1) !important;
}
.second-level-menu:hover {
  background: rgba(239, 195, 148, 1) !important;
  color: rgba(51, 53, 62, 1) !important;
}
.first-level-menu {
  a {
  }
}
.second-level-menu {
  width: 160px;
  height: 48px !important;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  line-height: 48px !important;
  background: #33353e;
  padding-left: 24px !important;
}
// .el-menu-item.is-active {
//   border-bottom: none;
//   color: rgba(237, 189, 136, 1) !important;
//   // span {
//   //   color: rgba(237, 189, 136, 1) !important;
//   // }
// }

.el-menu-demo {
  .el-menu-item {
  }
  li {
    height: 60px;
    line-height: 60px !important;
    padding: 0 24px !important;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    a {
      text-decoration: none;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue